import {
	getUserProperty,
	setUserProperties,
} from '@atlassian/jira-common-rest/src/api/latest/user-properties/index.tsx';
import { trackFetchErrors } from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import type { AccountId } from '@atlassian/jira-shared-types/src/general.tsx';
import { PACKAGE_NAME } from '../../common/constants.tsx';
import type { SettingsGet } from '../../common/types.tsx';

const key = 'announcementBannerDismissedLast';

export const get = async (accoundId: AccountId | null): Promise<string | null> => {
	try {
		return accoundId != null
			? (
					await getUserProperty<{
						hashId: string;
					}>(accoundId, key)
				).hashId
			: null;
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		// 404 - property has not been previously set
		if (error.statusCode === 404) {
			return null;
		}

		trackFetchErrors({
			error,
			id: 'userDismissGet',
			packageName: PACKAGE_NAME,
		});
		throw error;
	}
};

export const set = async (accoundId: AccountId, hashId: SettingsGet['hashId']): Promise<void> => {
	try {
		return await setUserProperties(accoundId, key, JSON.stringify({ hashId }));
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		trackFetchErrors({
			error,
			id: 'userDismissSet',
			packageName: PACKAGE_NAME,
		});
		throw error;
	}
};
